import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dab75f36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card card-table mb-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-table me-2" }),
  /*#__PURE__*/_createTextVNode("ผลการดำเนินการแยกตามประเภทโครงการ ")
], -1))
const _hoisted_3 = { class: "card-body pb-0" }
const _hoisted_4 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_5 = { class: "table" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ประเภทโครงการ"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "จำนวนโครงการ"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "คิดเป็นร้อยละ"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "งบประมาณที่ได้รับ")
  ])
], -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "text-center text-danger"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-exclamation-triangle me-2" }),
  /*#__PURE__*/_createTextVNode("ไม่มีข้อมูล ")
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-circle me-2" }, null, -1))
const _hoisted_11 = { class: "text-end" }
const _hoisted_12 = { class: "text-end" }
const _hoisted_13 = { class: "text-end" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "row",
  colspan: "2",
  class: "text-center"
}, "รวมทั้งสิ้น", -1))
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("table", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("tbody", null, [
                (_ctx.projectTypes.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_7, _hoisted_9))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.projectTypes, (projectType, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                        _createElementVNode("td", null, [
                          _hoisted_10,
                          _createTextVNode(_toDisplayString(projectType.name), 1)
                        ]),
                        _createElementVNode("td", _hoisted_11, _toDisplayString(Number(projectType.count).toLocaleString('en', { minimumFractionDigits: 0, maximumFractionDigits: 0 })), 1),
                        _createElementVNode("td", _hoisted_12, _toDisplayString(Number(projectType.percent).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + "%", 1),
                        _createElementVNode("td", _hoisted_13, _toDisplayString(Number(projectType.budget).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })), 1)
                      ]))
                    }), 128))
              ]),
              (_ctx.projectTypes.length > 0)
                ? (_openBlock(), _createElementBlock("tfoot", _hoisted_14, [
                    _createElementVNode("tr", null, [
                      _hoisted_15,
                      _createElementVNode("td", _hoisted_16, _toDisplayString(Number(_ctx.projectTypes.reduce((total, m) => total + m.count, 0)).toLocaleString('en', { minimumFractionDigits: 0, maximumFractionDigits: 0 })), 1),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(Number(_ctx.projectTypes.reduce((total, m) => total + m.percent, 0)).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + "%", 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(Number(_ctx.projectTypes.reduce((total, m) => total + m.budget, 0)).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
    ])
  ]))
}